__turbopack_context__.v({
  "body-20": "bento-three-module-scss-module__gobqoG__body-20",
  "body-20--lg": "bento-three-module-scss-module__gobqoG__body-20--lg",
  "body-20--md": "bento-three-module-scss-module__gobqoG__body-20--md",
  "body-20--sm": "bento-three-module-scss-module__gobqoG__body-20--sm",
  "body-20--tablet": "bento-three-module-scss-module__gobqoG__body-20--tablet",
  "body-20--xl": "bento-three-module-scss-module__gobqoG__body-20--xl",
  "body-20--xs": "bento-three-module-scss-module__gobqoG__body-20--xs",
  "body-20--xxs": "bento-three-module-scss-module__gobqoG__body-20--xxs",
  "body-2xl": "bento-three-module-scss-module__gobqoG__body-2xl",
  "body-2xl--lg": "bento-three-module-scss-module__gobqoG__body-2xl--lg",
  "body-2xl--md": "bento-three-module-scss-module__gobqoG__body-2xl--md",
  "body-2xl--sm": "bento-three-module-scss-module__gobqoG__body-2xl--sm",
  "body-2xl--tablet": "bento-three-module-scss-module__gobqoG__body-2xl--tablet",
  "body-2xl--xl": "bento-three-module-scss-module__gobqoG__body-2xl--xl",
  "body-2xl--xs": "bento-three-module-scss-module__gobqoG__body-2xl--xs",
  "body-2xl--xxs": "bento-three-module-scss-module__gobqoG__body-2xl--xxs",
  "body-2xs": "bento-three-module-scss-module__gobqoG__body-2xs",
  "body-2xs--lg": "bento-three-module-scss-module__gobqoG__body-2xs--lg",
  "body-2xs--md": "bento-three-module-scss-module__gobqoG__body-2xs--md",
  "body-2xs--sm": "bento-three-module-scss-module__gobqoG__body-2xs--sm",
  "body-2xs--tablet": "bento-three-module-scss-module__gobqoG__body-2xs--tablet",
  "body-2xs--xl": "bento-three-module-scss-module__gobqoG__body-2xs--xl",
  "body-2xs--xs": "bento-three-module-scss-module__gobqoG__body-2xs--xs",
  "body-2xs--xxs": "bento-three-module-scss-module__gobqoG__body-2xs--xxs",
  "body-3xl": "bento-three-module-scss-module__gobqoG__body-3xl",
  "body-3xl--lg": "bento-three-module-scss-module__gobqoG__body-3xl--lg",
  "body-3xl--md": "bento-three-module-scss-module__gobqoG__body-3xl--md",
  "body-3xl--sm": "bento-three-module-scss-module__gobqoG__body-3xl--sm",
  "body-3xl--tablet": "bento-three-module-scss-module__gobqoG__body-3xl--tablet",
  "body-3xl--xl": "bento-three-module-scss-module__gobqoG__body-3xl--xl",
  "body-3xl--xs": "bento-three-module-scss-module__gobqoG__body-3xl--xs",
  "body-3xl--xxs": "bento-three-module-scss-module__gobqoG__body-3xl--xxs",
  "body-3xs": "bento-three-module-scss-module__gobqoG__body-3xs",
  "body-3xs--lg": "bento-three-module-scss-module__gobqoG__body-3xs--lg",
  "body-3xs--md": "bento-three-module-scss-module__gobqoG__body-3xs--md",
  "body-3xs--sm": "bento-three-module-scss-module__gobqoG__body-3xs--sm",
  "body-3xs--tablet": "bento-three-module-scss-module__gobqoG__body-3xs--tablet",
  "body-3xs--xl": "bento-three-module-scss-module__gobqoG__body-3xs--xl",
  "body-3xs--xs": "bento-three-module-scss-module__gobqoG__body-3xs--xs",
  "body-3xs--xxs": "bento-three-module-scss-module__gobqoG__body-3xs--xxs",
  "body-lg": "bento-three-module-scss-module__gobqoG__body-lg",
  "body-lg--lg": "bento-three-module-scss-module__gobqoG__body-lg--lg",
  "body-lg--md": "bento-three-module-scss-module__gobqoG__body-lg--md",
  "body-lg--sm": "bento-three-module-scss-module__gobqoG__body-lg--sm",
  "body-lg--tablet": "bento-three-module-scss-module__gobqoG__body-lg--tablet",
  "body-lg--xl": "bento-three-module-scss-module__gobqoG__body-lg--xl",
  "body-lg--xs": "bento-three-module-scss-module__gobqoG__body-lg--xs",
  "body-lg--xxs": "bento-three-module-scss-module__gobqoG__body-lg--xxs",
  "body-md": "bento-three-module-scss-module__gobqoG__body-md",
  "body-md--lg": "bento-three-module-scss-module__gobqoG__body-md--lg",
  "body-md--md": "bento-three-module-scss-module__gobqoG__body-md--md",
  "body-md--sm": "bento-three-module-scss-module__gobqoG__body-md--sm",
  "body-md--tablet": "bento-three-module-scss-module__gobqoG__body-md--tablet",
  "body-md--xl": "bento-three-module-scss-module__gobqoG__body-md--xl",
  "body-md--xs": "bento-three-module-scss-module__gobqoG__body-md--xs",
  "body-md--xxs": "bento-three-module-scss-module__gobqoG__body-md--xxs",
  "body-xl": "bento-three-module-scss-module__gobqoG__body-xl",
  "body-xl--lg": "bento-three-module-scss-module__gobqoG__body-xl--lg",
  "body-xl--md": "bento-three-module-scss-module__gobqoG__body-xl--md",
  "body-xl--sm": "bento-three-module-scss-module__gobqoG__body-xl--sm",
  "body-xl--tablet": "bento-three-module-scss-module__gobqoG__body-xl--tablet",
  "body-xl--xl": "bento-three-module-scss-module__gobqoG__body-xl--xl",
  "body-xl--xs": "bento-three-module-scss-module__gobqoG__body-xl--xs",
  "body-xl--xxs": "bento-three-module-scss-module__gobqoG__body-xl--xxs",
  "body-xs": "bento-three-module-scss-module__gobqoG__body-xs",
  "body-xs--lg": "bento-three-module-scss-module__gobqoG__body-xs--lg",
  "body-xs--md": "bento-three-module-scss-module__gobqoG__body-xs--md",
  "body-xs--sm": "bento-three-module-scss-module__gobqoG__body-xs--sm",
  "body-xs--tablet": "bento-three-module-scss-module__gobqoG__body-xs--tablet",
  "body-xs--xl": "bento-three-module-scss-module__gobqoG__body-xs--xl",
  "body-xs--xs": "bento-three-module-scss-module__gobqoG__body-xs--xs",
  "body-xs--xxs": "bento-three-module-scss-module__gobqoG__body-xs--xxs",
  "boxFirst": "bento-three-module-scss-module__gobqoG__boxFirst",
  "boxFirstContainer": "bento-three-module-scss-module__gobqoG__boxFirstContainer",
  "boxOneContent": "bento-three-module-scss-module__gobqoG__boxOneContent",
  "boxSecond": "bento-three-module-scss-module__gobqoG__boxSecond",
  "boxSecondContainer": "bento-three-module-scss-module__gobqoG__boxSecondContainer",
  "boxTwoContent": "bento-three-module-scss-module__gobqoG__boxTwoContent",
  "container": "bento-three-module-scss-module__gobqoG__container",
  "flexContainer": "bento-three-module-scss-module__gobqoG__flexContainer",
  "heading-120": "bento-three-module-scss-module__gobqoG__heading-120",
  "heading-120--lg": "bento-three-module-scss-module__gobqoG__heading-120--lg",
  "heading-120--md": "bento-three-module-scss-module__gobqoG__heading-120--md",
  "heading-120--sm": "bento-three-module-scss-module__gobqoG__heading-120--sm",
  "heading-120--tablet": "bento-three-module-scss-module__gobqoG__heading-120--tablet",
  "heading-120--xl": "bento-three-module-scss-module__gobqoG__heading-120--xl",
  "heading-120--xs": "bento-three-module-scss-module__gobqoG__heading-120--xs",
  "heading-120--xxs": "bento-three-module-scss-module__gobqoG__heading-120--xxs",
  "heading-128": "bento-three-module-scss-module__gobqoG__heading-128",
  "heading-128--lg": "bento-three-module-scss-module__gobqoG__heading-128--lg",
  "heading-128--md": "bento-three-module-scss-module__gobqoG__heading-128--md",
  "heading-128--sm": "bento-three-module-scss-module__gobqoG__heading-128--sm",
  "heading-128--tablet": "bento-three-module-scss-module__gobqoG__heading-128--tablet",
  "heading-128--xl": "bento-three-module-scss-module__gobqoG__heading-128--xl",
  "heading-128--xs": "bento-three-module-scss-module__gobqoG__heading-128--xs",
  "heading-128--xxs": "bento-three-module-scss-module__gobqoG__heading-128--xxs",
  "heading-150": "bento-three-module-scss-module__gobqoG__heading-150",
  "heading-150--lg": "bento-three-module-scss-module__gobqoG__heading-150--lg",
  "heading-150--md": "bento-three-module-scss-module__gobqoG__heading-150--md",
  "heading-150--sm": "bento-three-module-scss-module__gobqoG__heading-150--sm",
  "heading-150--tablet": "bento-three-module-scss-module__gobqoG__heading-150--tablet",
  "heading-150--xl": "bento-three-module-scss-module__gobqoG__heading-150--xl",
  "heading-150--xs": "bento-three-module-scss-module__gobqoG__heading-150--xs",
  "heading-150--xxs": "bento-three-module-scss-module__gobqoG__heading-150--xxs",
  "heading-2xl": "bento-three-module-scss-module__gobqoG__heading-2xl",
  "heading-2xl--lg": "bento-three-module-scss-module__gobqoG__heading-2xl--lg",
  "heading-2xl--md": "bento-three-module-scss-module__gobqoG__heading-2xl--md",
  "heading-2xl--sm": "bento-three-module-scss-module__gobqoG__heading-2xl--sm",
  "heading-2xl--tablet": "bento-three-module-scss-module__gobqoG__heading-2xl--tablet",
  "heading-2xl--xl": "bento-three-module-scss-module__gobqoG__heading-2xl--xl",
  "heading-2xl--xs": "bento-three-module-scss-module__gobqoG__heading-2xl--xs",
  "heading-2xl--xxs": "bento-three-module-scss-module__gobqoG__heading-2xl--xxs",
  "heading-3xl": "bento-three-module-scss-module__gobqoG__heading-3xl",
  "heading-3xl--lg": "bento-three-module-scss-module__gobqoG__heading-3xl--lg",
  "heading-3xl--md": "bento-three-module-scss-module__gobqoG__heading-3xl--md",
  "heading-3xl--sm": "bento-three-module-scss-module__gobqoG__heading-3xl--sm",
  "heading-3xl--tablet": "bento-three-module-scss-module__gobqoG__heading-3xl--tablet",
  "heading-3xl--xl": "bento-three-module-scss-module__gobqoG__heading-3xl--xl",
  "heading-3xl--xs": "bento-three-module-scss-module__gobqoG__heading-3xl--xs",
  "heading-3xl--xxs": "bento-three-module-scss-module__gobqoG__heading-3xl--xxs",
  "heading-4xl": "bento-three-module-scss-module__gobqoG__heading-4xl",
  "heading-4xl--lg": "bento-three-module-scss-module__gobqoG__heading-4xl--lg",
  "heading-4xl--md": "bento-three-module-scss-module__gobqoG__heading-4xl--md",
  "heading-4xl--sm": "bento-three-module-scss-module__gobqoG__heading-4xl--sm",
  "heading-4xl--tablet": "bento-three-module-scss-module__gobqoG__heading-4xl--tablet",
  "heading-4xl--xl": "bento-three-module-scss-module__gobqoG__heading-4xl--xl",
  "heading-4xl--xs": "bento-three-module-scss-module__gobqoG__heading-4xl--xs",
  "heading-4xl--xxs": "bento-three-module-scss-module__gobqoG__heading-4xl--xxs",
  "heading-5xl": "bento-three-module-scss-module__gobqoG__heading-5xl",
  "heading-5xl--lg": "bento-three-module-scss-module__gobqoG__heading-5xl--lg",
  "heading-5xl--md": "bento-three-module-scss-module__gobqoG__heading-5xl--md",
  "heading-5xl--sm": "bento-three-module-scss-module__gobqoG__heading-5xl--sm",
  "heading-5xl--tablet": "bento-three-module-scss-module__gobqoG__heading-5xl--tablet",
  "heading-5xl--xl": "bento-three-module-scss-module__gobqoG__heading-5xl--xl",
  "heading-5xl--xs": "bento-three-module-scss-module__gobqoG__heading-5xl--xs",
  "heading-5xl--xxs": "bento-three-module-scss-module__gobqoG__heading-5xl--xxs",
  "heading-60": "bento-three-module-scss-module__gobqoG__heading-60",
  "heading-60--lg": "bento-three-module-scss-module__gobqoG__heading-60--lg",
  "heading-60--md": "bento-three-module-scss-module__gobqoG__heading-60--md",
  "heading-60--sm": "bento-three-module-scss-module__gobqoG__heading-60--sm",
  "heading-60--tablet": "bento-three-module-scss-module__gobqoG__heading-60--tablet",
  "heading-60--xl": "bento-three-module-scss-module__gobqoG__heading-60--xl",
  "heading-60--xs": "bento-three-module-scss-module__gobqoG__heading-60--xs",
  "heading-60--xxs": "bento-three-module-scss-module__gobqoG__heading-60--xxs",
  "heading-70": "bento-three-module-scss-module__gobqoG__heading-70",
  "heading-70--lg": "bento-three-module-scss-module__gobqoG__heading-70--lg",
  "heading-70--md": "bento-three-module-scss-module__gobqoG__heading-70--md",
  "heading-70--sm": "bento-three-module-scss-module__gobqoG__heading-70--sm",
  "heading-70--tablet": "bento-three-module-scss-module__gobqoG__heading-70--tablet",
  "heading-70--xl": "bento-three-module-scss-module__gobqoG__heading-70--xl",
  "heading-70--xs": "bento-three-module-scss-module__gobqoG__heading-70--xs",
  "heading-70--xxs": "bento-three-module-scss-module__gobqoG__heading-70--xxs",
  "heading-90": "bento-three-module-scss-module__gobqoG__heading-90",
  "heading-90--lg": "bento-three-module-scss-module__gobqoG__heading-90--lg",
  "heading-90--md": "bento-three-module-scss-module__gobqoG__heading-90--md",
  "heading-90--sm": "bento-three-module-scss-module__gobqoG__heading-90--sm",
  "heading-90--tablet": "bento-three-module-scss-module__gobqoG__heading-90--tablet",
  "heading-90--xl": "bento-three-module-scss-module__gobqoG__heading-90--xl",
  "heading-90--xs": "bento-three-module-scss-module__gobqoG__heading-90--xs",
  "heading-90--xxs": "bento-three-module-scss-module__gobqoG__heading-90--xxs",
  "heading-lg": "bento-three-module-scss-module__gobqoG__heading-lg",
  "heading-lg--lg": "bento-three-module-scss-module__gobqoG__heading-lg--lg",
  "heading-lg--md": "bento-three-module-scss-module__gobqoG__heading-lg--md",
  "heading-lg--sm": "bento-three-module-scss-module__gobqoG__heading-lg--sm",
  "heading-lg--tablet": "bento-three-module-scss-module__gobqoG__heading-lg--tablet",
  "heading-lg--xl": "bento-three-module-scss-module__gobqoG__heading-lg--xl",
  "heading-lg--xs": "bento-three-module-scss-module__gobqoG__heading-lg--xs",
  "heading-lg--xxs": "bento-three-module-scss-module__gobqoG__heading-lg--xxs",
  "heading-md": "bento-three-module-scss-module__gobqoG__heading-md",
  "heading-md--lg": "bento-three-module-scss-module__gobqoG__heading-md--lg",
  "heading-md--md": "bento-three-module-scss-module__gobqoG__heading-md--md",
  "heading-md--sm": "bento-three-module-scss-module__gobqoG__heading-md--sm",
  "heading-md--tablet": "bento-three-module-scss-module__gobqoG__heading-md--tablet",
  "heading-md--xl": "bento-three-module-scss-module__gobqoG__heading-md--xl",
  "heading-md--xs": "bento-three-module-scss-module__gobqoG__heading-md--xs",
  "heading-md--xxs": "bento-three-module-scss-module__gobqoG__heading-md--xxs",
  "heading-sm": "bento-three-module-scss-module__gobqoG__heading-sm",
  "heading-sm--lg": "bento-three-module-scss-module__gobqoG__heading-sm--lg",
  "heading-sm--md": "bento-three-module-scss-module__gobqoG__heading-sm--md",
  "heading-sm--sm": "bento-three-module-scss-module__gobqoG__heading-sm--sm",
  "heading-sm--tablet": "bento-three-module-scss-module__gobqoG__heading-sm--tablet",
  "heading-sm--xl": "bento-three-module-scss-module__gobqoG__heading-sm--xl",
  "heading-sm--xs": "bento-three-module-scss-module__gobqoG__heading-sm--xs",
  "heading-sm--xxs": "bento-three-module-scss-module__gobqoG__heading-sm--xxs",
  "heading-xl": "bento-three-module-scss-module__gobqoG__heading-xl",
  "heading-xl--lg": "bento-three-module-scss-module__gobqoG__heading-xl--lg",
  "heading-xl--md": "bento-three-module-scss-module__gobqoG__heading-xl--md",
  "heading-xl--sm": "bento-three-module-scss-module__gobqoG__heading-xl--sm",
  "heading-xl--tablet": "bento-three-module-scss-module__gobqoG__heading-xl--tablet",
  "heading-xl--xl": "bento-three-module-scss-module__gobqoG__heading-xl--xl",
  "heading-xl--xs": "bento-three-module-scss-module__gobqoG__heading-xl--xs",
  "heading-xl--xxs": "bento-three-module-scss-module__gobqoG__heading-xl--xxs",
  "heading-xs": "bento-three-module-scss-module__gobqoG__heading-xs",
  "heading-xs--lg": "bento-three-module-scss-module__gobqoG__heading-xs--lg",
  "heading-xs--md": "bento-three-module-scss-module__gobqoG__heading-xs--md",
  "heading-xs--sm": "bento-three-module-scss-module__gobqoG__heading-xs--sm",
  "heading-xs--tablet": "bento-three-module-scss-module__gobqoG__heading-xs--tablet",
  "heading-xs--xl": "bento-three-module-scss-module__gobqoG__heading-xs--xl",
  "heading-xs--xs": "bento-three-module-scss-module__gobqoG__heading-xs--xs",
  "heading-xs--xxs": "bento-three-module-scss-module__gobqoG__heading-xs--xxs",
  "heading-xxs": "bento-three-module-scss-module__gobqoG__heading-xxs",
  "heading-xxs--lg": "bento-three-module-scss-module__gobqoG__heading-xxs--lg",
  "heading-xxs--md": "bento-three-module-scss-module__gobqoG__heading-xxs--md",
  "heading-xxs--sm": "bento-three-module-scss-module__gobqoG__heading-xxs--sm",
  "heading-xxs--tablet": "bento-three-module-scss-module__gobqoG__heading-xxs--tablet",
  "heading-xxs--xl": "bento-three-module-scss-module__gobqoG__heading-xxs--xl",
  "heading-xxs--xs": "bento-three-module-scss-module__gobqoG__heading-xxs--xs",
  "heading-xxs--xxs": "bento-three-module-scss-module__gobqoG__heading-xxs--xxs",
  "large-prompt": "bento-three-module-scss-module__gobqoG__large-prompt",
  "large-prompt--lg": "bento-three-module-scss-module__gobqoG__large-prompt--lg",
  "large-prompt--md": "bento-three-module-scss-module__gobqoG__large-prompt--md",
  "large-prompt--sm": "bento-three-module-scss-module__gobqoG__large-prompt--sm",
  "large-prompt--tablet": "bento-three-module-scss-module__gobqoG__large-prompt--tablet",
  "large-prompt--xl": "bento-three-module-scss-module__gobqoG__large-prompt--xl",
  "large-prompt--xs": "bento-three-module-scss-module__gobqoG__large-prompt--xs",
  "large-prompt--xxs": "bento-three-module-scss-module__gobqoG__large-prompt--xxs",
  "reverse": "bento-three-module-scss-module__gobqoG__reverse",
});
